import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

export const shippingTitle = (
    <FormattedMessage id="pdpBlurb.shippingTitle" defaultMessage="Shipping" />
);

export const leadTimeTitle = (
    <FormattedMessage id="pdpBlurb.leadTimeTitle" defaultMessage="Estimated Production Time" />
);

export const buyerProtectionTitle = (
    <FormattedMessage
        id="pdpBlurb.buyerProtectionTitle"
        defaultMessage={'Buyer Protection Guarantee'}
    />
);

export const buyerProtectionText = (
    <FormattedMessage
        id="pdpBlurb.buyerProtectionText"
        defaultMessage={'Your purchase will arrive as described'}
    />
);

export const pcsTitle = (
    <FormattedMessage id="pdpBlurb.pcsTitle" defaultMessage="Private Client Service" />
);
export const pcsText = name => (
    <FormattedMessage
        id="pdpBlurb.pcsText"
        defaultMessage="Contact your specialist, {name}, for dedicated assistance"
        values={{ name }}
    />
);

export const returnsTitle = (
    <FormattedMessage id="pdpBlurb.returnsTitle" defaultMessage="Worry-Free Returns" />
);
export const returnsText = returnPolicyLength => (
    <FormattedMessage
        id="pdpBlurb.returnsText"
        defaultMessage={`This piece can be returned within {returnPolicyLength, number} {returnPolicyLength, plural,
            one {day}
            other {days}
        }.`}
        values={{ returnPolicyLength }}
    />
);
export const returnsCta = (
    <FormattedMessage id="pdpBlurb.returnsCta" defaultMessage="View Details" />
);

const REWARD_AMOUNT = 50;
const REWARD_SPEND_AMOUNT = 5000;
const rewardAmount = (
    <FormattedNumber
        style="currency"
        currencyDisplay="symbol"
        maximumFractionDigits={0}
        minimumFractionDigits={0}
        currency={'USD'}
        value={REWARD_AMOUNT}
    />
);
const spendAmount = (
    <FormattedNumber
        style="currency"
        currencyDisplay="symbol"
        maximumFractionDigits={0}
        minimumFractionDigits={0}
        currency={'USD'}
        value={REWARD_SPEND_AMOUNT}
    />
);

export const tradeLoyaltyTitle = (
    <FormattedMessage
        id="pdp.PdpSharedBlurbTradeLoyalty.tradeRewardsTitle"
        defaultMessage="Trade Rewards: "
    />
);

export const tpnTradeLoyaltyMessage = (
    <FormattedMessage
        id="pdp.PdpSharedBlurbTradeLoyalty.tpnTradeRewardsDescription"
        defaultMessage="Get cash back and editorial coverage for your firm."
    />
);

export const tradeLoyaltyEnrolledLink = (
    <FormattedMessage
        id="pdp.PdpSharedBlurbTradeLoyalty.tradeRewardsEnrolledLink"
        defaultMessage="View Rewards"
    />
);

export const tradeLoyaltyUnenrolledLink = (
    <FormattedMessage
        id="pdp.PdpSharedBlurbTradeLoyalty.tradeRewardsUnenrolledLink"
        defaultMessage="Enroll Now"
    />
);
